<template>
  <div class="compsmain">
    <div class="left">
      <div class="icon">
        <img src="../img/ws.png" alt="">
      </div>
      <div class="text">风扇<br />控制</div>
    </div>
    <div class="right" v-loading="loading" element-loading-text="指令发送中.." element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="ritem">
        <div class="name">
          <div class="point" />当前温度
        </div>
        <div class="content">
          <div class="icon">
            <div><img src="../img/temp.png" alt=""></div>
            <div class="dvalue">{{ resultdata }}</div>
          </div>
          <div class="text">温度<br />正常</div>
        </div>
      </div>
      <div class="ritem">
        <div class="name">
          <div class="point" />风扇运行状态
        </div>
        <div class="content">
          <div class="icon">
            <img :src="fsstatus ? require('../img/winded.gif') : require('../img/ws.png')" alt="">
          </div>
          <div class="text">{{ fsstatus ? '运行中' : '已关闭' }}</div>
        </div>
      </div>
      <div class="ritem">
        <img src="../img/tip.png" alt="">
        {{ fsstatus ? '风扇正在运行中' : '风扇已关闭' }}
      </div>
      <div class="ritem">
        <div class="name">
          <div class="point" />风扇控制
        </div>
        <div>
          打开风扇
          <el-switch v-model="fsstatus" active-color="#ff009d" inactive-color="#5B50A9" @change="fengshanclick">
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      fsstatus: false,
      status: '1',
      loading: false,
      resultdata: [],
    }
  },
  props: {

  },
  mounted() {
    this.fetchdata()
  },
  methods: {
    fetchdata() {
      let xhr = new XMLHttpRequest()
      xhr.open('POST', '/klgapi/chat/gygpt_chat', true)
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send(JSON.stringify({
        query: '温度',
        stream: false,
        model_name: '英鸣产业大模型',
        temperature: '0.7',
        mode: '晓知因',
        source: 'CBox产品演示',
        clienttype: 'WEB'
      }));
      const that = this;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据 
          const res = JSON.parse(xhr.responseText)

          that.resultdata = res.answer.substr(res.answer.indexOf('：') + 1)
          console.log(that.resultdata)
        }
      }
    },
    fengshanclick() {
      this.loading = true;
      let xhr = new XMLHttpRequest()
      xhr.open('POST', '/klgapi/chat/gygpt_chat', true)
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send(JSON.stringify({
        query: this.fsstatus ? '打开风扇' : '关闭风扇',
        stream: false,
        model_name: '英鸣产业大模型',
        temperature: '0.7',
        mode: '晓知因',
        source: 'CBox产品演示',
        clienttype: 'WEB'
      }));
      const that = this;
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {  //固定写法
          //数据获取成功，获取服务器响应的数据 
          const res = JSON.parse(xhr.responseText)
          console.log(res)
          that.loading = false;
          that.$message({
            type: 'success',
            message: res.answer
          });
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
.compsmain {
  height: calc(100% - 40px);
  width: 100%;
  border-radius: 10px 0 0 10px;
  margin-top: 20px;
  display: flex;
  background: linear-gradient(180deg, #181B40 0%, #181A37 100%);
  box-shadow: 2px 2px 2px rgba(17, 19, 38, 0.82);
  border-radius: 7px;

  .left {
    width: 150px;
    background: linear-gradient(180deg, #565AB5 0%, #800A52 100%);
    box-shadow: 2px 2px 2px rgba(17, 19, 38, 0.82);
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;

    .icon {
      width: 100%;
      text-align: center;

      img {
        margin: 0 auto;
      }
    }

    .text {
      font-size: 30px;
      margin-top: 20px;
      color: white;
    }
  }

  .right {
    width: calc(100% - 150px);
    display: flex;
    flex-wrap: wrap;
    padding: 20px;

    .ritem {
      background: linear-gradient(275deg, #181B40 0%, #181A37 100%);
      box-shadow: 0px 0px 16px rgba(56, 41, 98, 0.42);
      border-radius: 10px;
      padding: 20px;
      margin: 20px;

      .name {
        color: white;
        display: flex;
        align-items: center;
        font-size: 22px;

        .point {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          background-color: #ff009d;
          border-radius: 50%;
        }
      }

      .content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        align-content: center;

        .icon {
          width: 120px;
          height: 120px;
          background: linear-gradient(180deg, #62d2ed 0%, #243fee 100%);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          align-content: center;
          margin: 20px 0;

          img {
            height: 70px;
          }

          .dvalue {
            text-align: center;
            color: white;
            font-weight: 600;
            width: 100%;
            font-size: 20px;
          }
        }

        .text {
          height: 200px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          align-content: center;
          margin-left: 20px;
          font-size: 22px;
          color: white;

        }
      }


    }

    .ritem:nth-child(1),
    .ritem:nth-child(2) {
      width: calc(50% - 40px);
      margin: 20px;
    }

    .ritem:nth-child(3) {
      width: 100%;
      margin: 40px 20px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      align-content: center;
      font-size: 22px;
      color: white;

      img {
        margin-right: 15px;
      }
    }

    .ritem:nth-child(4) {
      width: 100%;
      margin: 40px 20px;
      text-align: center;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      align-content: center;
      font-size: 22px;
      color: white;

      img {
        margin-right: 15px;
      }
    }
  }

}
</style>
